import React from "react";
import Container from "../components/Container";
import ImageChart from "../components/gallery/ImageChart";
import TopBannerSection from "../components/TopBannerSection";
import image from "../assets/ResortGallery/RG15.jpg";

const Gallery = () => {
    return (
      <>
        <Container>
          <TopBannerSection
            Image={image}
            pageName={"GALLERY"}
            Quote={"Captured Experiences"}
          />
           <br />
          <ImageChart />
        </Container>
      </>
    );
};

export default Gallery;
